import PageHeader from '../components/PageHeader';
import Footer from '../components/Footer';
import './Pages.css';

function About() {
  return (
    <div className="Page">
      <PageHeader />
      <div className="Page-container">
        <h1>About</h1>

        <section className="Page-section">
          <h2>30 Years of Excellence</h2>
          <p>
            With over three decades of experience in cybersecurity and information technology,
            cybersmith.io Incorporated brings deep expertise and proven methodologies to protect your organization's
            most valuable assets. Our extensive background spans the evolution of technology from early
            computing systems to today's complex cloud environments.
          </p>
        </section>

        <section className="Page-section">
          <h2>Industry Experience</h2>
          <p>
            Our team has successfully delivered security solutions across diverse industries, understanding
            the unique challenges and regulatory requirements of each sector:
          </p>
          <ul>
            <li><strong>Tech Startups</strong> - Helping innovative companies build security into their foundation</li>
            <li><strong>Telecommunications</strong> - Securing critical infrastructure and customer data</li>
            <li><strong>Financial Services</strong> - Meeting stringent compliance and protecting sensitive financial data</li>
            <li><strong>Multinational Organizations</strong> - Managing security across global operations and diverse regulatory environments</li>
            <li><strong>Government</strong> - Delivering solutions that meet strict security standards and compliance requirements</li>
          </ul>
        </section>

        <section className="Page-section">
          <h2>Technical Expertise</h2>
          <p>
            Our comprehensive technical experience enables us to secure every layer of your technology stack:
          </p>
          <ul>
            <li><strong>Unix/Linux</strong> - Deep system-level security hardening and administration</li>
            <li><strong>Networking</strong> - Securing network infrastructure, segmentation, and traffic analysis</li>
            <li><strong>Database</strong> - Database security, encryption, and access controls</li>
            <li><strong>Storage and Backup</strong> - Data protection, disaster recovery, and business continuity</li>
            <li><strong>Application Development</strong> - Secure coding practices and application security testing</li>
            <li><strong>Cloud</strong> - Cloud security architecture across AWS, Azure, and GCP</li>
            <li><strong>Identity and Access Management</strong> - IAM strategy, implementation, and governance</li>
            <li><strong>Vulnerability Management</strong> - Continuous assessment and remediation programs</li>
          </ul>
        </section>

        <section className="Page-section">
          <h2>Our Approach</h2>
          <p>
            We combine decades of hands-on experience with cutting-edge security practices to deliver
            solutions that are both technically sound and business-aligned. Our approach is built on:
          </p>
          <ul>
            <li>Proactive threat identification and mitigation</li>
            <li>Risk-based security strategies tailored to your business</li>
            <li>Practical, implementable security solutions</li>
            <li>Knowledge transfer and team empowerment</li>
            <li>Continuous improvement and adaptation to emerging threats</li>
          </ul>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default About;
